import { Component, OnInit, ChangeDetectorRef, ApplicationRef, ViewChild} from '@angular/core';
import { BaseService } from '../../../services/base.services';
import {NgbDate, NgbCalendar, NgbDateParserFormatter, NgbTabsetConfig, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';

import pageSettings from '../../../config/page-settings';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { formatDate} from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material';
import { DaterangepickerComponent, DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { NgxChartsModule, id } from '@swimlane/ngx-charts';
import * as moment from 'moment';
import 'nvd3';
declare var Highcharts: any;
declare var nv: any;
declare var html2canvas:any;
import Swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';

import * as global from '../../../config/globals';
@Component({
  selector: 'poll',
  templateUrl: './poll.html',
  styleUrls: ['poll.css']
})

export class PollPage implements OnInit{
  private data:Array<any> = [];
  enviando = false;
  cargando = false;
  verCorreo = 0;
  verFFin = 0;
  pageSettings = pageSettings;
  finish = false;
  todaySurvey = false;
  country = 'chile';
  final = false;
  listTodaySurvey = false;
  nombre;
  apellido;
  email: any = '';
  direccion;
  empresa = '';
  oficina;
  responseForm;
  warning;
  dataUser;
  currentOffice = 1;
  currentCompany = 1;
  otraEmpresa = false;
  otraOficina = false;
  otraEnfermedad = false;
  edad;
  show = true;
  show2 = true;
  paso1= false;
  paso2= false;
  paso3= false;
  loading = false;
  encuesta: any;
  solicitud:any = {};
  mostrarDeclaracion = false;
  mostrarEstado = false;
  nombres;
  apellidos;
  telefono;
  hash;
  tareas: any = [
    {Tarea: 'Bloqueo'},
    {Tarea: ' Espacios confinados'},
    {Tarea: 'Izaje de Carga'},
    {Tarea: 'Trabajos en Caliente'},
  ];
  datosEncuestadosLocal;
  declaracion = false;
  sinRiesgo = false;
  storage;
  solicitudSeleccionada:any = {};
  emailIncorrecto = false;
  inhabilitarCampo = false;
  esAdministrador = false;
  empresaSeleccionada = 1;
  areaSeleccionada = 1;
  finalEstado = false;
  ocultarChart = false;
  listEmpresas: any = [];
  listArea: any = [];
  listEstadosSolicitudPersonal:any = [];
  fechaInicio: NgbDateStruct;
  horaInicio: any;
  fechaFin:NgbDateStruct;
  esBloqueo = 0;
  horaFin:any;
  motivo: any;
  rut: any;
  total = 0;
  aprobadas = 0;
  rechazadas = 0;
  listSolicitudes:any = [];
  listSolicitudesFilter:any = [];
  listVisitas:any = [];
  listNuevasPersonas = [];
  disableRut= false;
  listPersonasVisitantes = []
  urlAdministrador = false;
  rangoFechaInicio: any;
  rangoFechaFin:any;
  buscar;
  buscarSolicitud;
  esGrupal = false;
  showQR= false;
  caja1 = 0;
  caja2 = 0;
  caja3 = 0;
  caja4 = 0;
  paginaRealizarOtra = false;
  listPersonal: any = [];
  telefonosGerencia: any = [];
  numPersonas:any = 1;
    /* Daterangepicker */
    rangoFecha: {startDate: moment.Moment, endDate: moment.Moment};
    @ViewChild(DaterangepickerDirective, {static: true}) pickerDirective: DaterangepickerDirective;
    inlineDate: any;
    inlineDateTime: any;
    picker: DaterangepickerComponent;
    alwaysShowCalendars: boolean;
    showRangeLabelOnInput: boolean;
    keepCalendarOpeningWithRange: boolean;
    prevDate: any = moment().subtract('days', 15).format('D MMMM') + ' - ' + moment().subtract('days', 8).format('D MMMM YYYY');
    ranges: any = {
      'Hoy': [moment(), moment()],
      //'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      '7 días': [moment().subtract(6, 'days'), moment()],
      '30 días': [moment().subtract(29, 'days'), moment()],
      //'This Month': [moment().startOf('month'), moment().endOf('month')],
      'Mes pasado': [
        moment()
          .subtract(1, 'month')
          .startOf('month'),
        moment()
          .subtract(1, 'month')
          .endOf('month')
      ]
    };
    locale: any = {
      format: 'D MMMM YYYY',
      displayFormat: 'D MMMM YYYY',
      separator: ' - ',
      cancelLabel: 'Cancelar',
      applyLabel: 'Aceptar',
      clearLabel: 'Limpiar'
    }
  

    multi: any[];
    view: any[] = [700, 400];
    mostrarDetalle = false;
    mostrarDetalleTodoPersonal = false;
    // options
    showXAxis: boolean = true;
    showYAxis: boolean = true;
    gradient: boolean = true;
    showLegend: boolean = true;
    showXAxisLabel: boolean = true;
    xAxisLabel: string = 'Country';
    showYAxisLabel: boolean = true;
    yAxisLabel: string = 'Population';
    legendTitle: string = 'Years';
    colorScheme = {
      domain: ['#5AA454', '#C7B42C', '#AAAAAA']
    };

    listVisitantesActuales:any = [];
    administrador: any;
    listEncontrados: any = [];
    rutaQRCompartir = 'rutaQR';
    rutaQRPase = 'rutaQR';
    imgQRCompartir;
    interval = true;

    selectedCar: number;

    cars = [
        { id: 1, name: 'Volvo' },
        { id: 2, name: 'Saab' },
        { id: 3, name: 'Opel' },
        { id: 4, name: 'Audi' },
    ];

  public constructor(
    private baseService: BaseService,
    private calendar: NgbCalendar, 
    public formatter: NgbDateParserFormatter,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private _formBuilder: FormBuilder,
    private router: Router,
    private cd : ChangeDetectorRef,
    private route: ActivatedRoute,
    private appRef: ApplicationRef,
    private config: NgbTabsetConfig
    ) {

      this.pageSettings.pageEmpty = true;
      config.justify = 'center';
      //config.type = 'pills';
      var fechaInicio = moment();
      var fechaFin = moment().add(12, 'hours');


      this.horaInicio =  {hour: parseInt(fechaInicio.format("HH")), minute: parseInt(fechaInicio.format("mm"))};
      this.horaFin =  {hour: parseInt(fechaFin.format("HH")), minute: 0};

      this.fechaInicio = {year: parseInt(fechaInicio.format("YYYY")), month: parseInt(fechaInicio.format("MM")), day: parseInt(fechaInicio.format("DD"))};
      this.fechaFin = {year: parseInt(fechaFin.format("YYYY")), month: parseInt(fechaFin.format("MM")), day: parseInt(fechaFin.format("DD"))};

      this.country = this.route.snapshot.paramMap.get('pais') == null ? 'chile' : this.route.snapshot.paramMap.get('pais');
      
      this.alwaysShowCalendars = true;
      this.keepCalendarOpeningWithRange = true;
      this.showRangeLabelOnInput = true;
      this.rangoFecha = {
        startDate: moment().subtract('days', 7),
        endDate: moment()
      };
  }

  async ngOnInit()  {


    //this.getEncuesta();
    //this.getDatosEncuestado();
 
    //this.getHash();
    this.getAreas();
    this.get_Tareas();
    //this.getEmpresas();
    await this.route.params.subscribe( params =>{
      if(params['rut']) {
        if(params['tipoUsuario'] == 'administrador'){
          localStorage.setItem('data', JSON.stringify({
            Division: 'DCH', 
            Validador: params['rut'],
            Captcha: 0
          })); 
          this.mostrarDeclaracion = false; 
          this.esAdministrador = false;
          this.urlAdministrador = true;
        }

        if(params['tipoUsuario'] == 'usuario'){
          localStorage.setItem('data', JSON.stringify({
            Division: 'DCH', 
            Validador: params['rut'],
            Captcha: 0
          })); 
        }
      }
    });

    this.storage = JSON.parse(localStorage.getItem('data'));

    var body = {
      Division: 'DCH',
      Validador: this.storage.Validador,
      Captcha: 0
    }

    await this.getLogin(body);

  }

  getDashboard(){
    var aprobadas = this.listSolicitudes.filter(x=> x.idEstado == 2);
    this.aprobadas = aprobadas ? aprobadas.length : 0;
    var rechazadas = this.listSolicitudes.filter(x=> x.idEstado == 3);
    this.rechazadas = rechazadas ? rechazadas.length : 0;
    this.total = this.listSolicitudes.length;        

    var dates = this.getDates();
    var dataChart = [];
    this.listArea.forEach(x=>{
      dataChart.push({name: x.nombre, color: global.COLOR_BLUE, series: this.getDataChart(x.nombre)});
    });

    this.multi = dataChart;
    
  }

  refresh(){
    window.location.reload();
  }

  cambiarTarea(tarea){
    this.tareas.filter(y=> y.Exclusivo == 1).map(x=>x.seleccionado = false);

    if(tarea.Exclusivo == 1){
      this.tareas.map(x=>x.seleccionado = false);
      tarea.seleccionado = !tarea.seleccionado;
    }else{
      tarea.seleccionado = !tarea.seleccionado;
    }
  }

  aprobarMarcados(){
    this.listSolicitudesFilter.forEach(x=>{
      if(x.idEstado == 1){
        x.idEstado = 2;
      }
    });
    this.toastr.success('todas las solicitudes ha sido aprobada');
  }

  cancelarSolicitud(solicitud){
    Swal.fire({
      title: '¿Esta seguro de cancelar la solicitud?',
      text: "Una vez cancelada debe ingresar una nueva solicitud",
      icon: 'error',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#6c757d',
      cancelButtonText: 'No',
      confirmButtonText: 'Sí, cancelar la solicitud!'
    }).then((result) => {
      if (result.value) {
        Swal.fire(
          'Cancelada!',
          'Su solicitud ha sido cancelada.',
          'success'
        );
        this.setEstadoPersonal(solicitud.idSolicitud, solicitud.idPersonal, 7); 
        this.rutaQRCompartir = ''; 
        this.mostrarEstado = false;
      }
    })
  }

  marcarIngreso(solicitud){
    Swal.fire({
      title: '¿Esta seguro de marcar su ingreso?',
      text: "Una vez ingresado obtendrá un código QR para efectos de control. Recuerde que al salir del área debe marcar su salida",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#6c757d',
      cancelButtonText: 'No',
      confirmButtonText: 'Sí, estoy ingresando al área'
    }).then((result) => {
      if (result.value) {

        this.setEstadoPersonal(solicitud.idSolicitud, solicitud.idPersonal, 4); 
        Swal.fire(
          '¡Ingresado!',
          'Usted ha ingresado al área.',
          'success'
        );
        this.rutaQRCompartir = ''; 
        this.mostrarEstado = false;
      }
    })
  }

  marcarSalida(solicitud){
    Swal.fire({
      title: '¿Esta seguro de marcar su salida?',
      text: "Una vez que marque su salida deberá salir del área",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#6c757d',
      cancelButtonText: 'No',
      confirmButtonText: 'Sí, estoy saliendo del área'
    }).then((result) => {
      if (result.value) {
        Swal.fire(
          '¡Ha marcado su salida!',
          'Debe salir del área. Si desea puede ingresar una nueva solicitud',
          'success'
        );
        this.setEstadoPersonal(solicitud.idSolicitud, solicitud.idPersonal, 5); 
        this.rutaQRCompartir = ''; 
        this.mostrarEstado = false;
      }
    })
  }
  
  salirAPP(solicitud){
    Swal.fire({
      title: '¿Esta seguro de salir de la aplicación?',
      text: "Una vez que salga debe ingresar nuevamente con su RUT",
      icon: 'error',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#6c757d',
      cancelButtonText: 'No',
      confirmButtonText: 'Sí, salir!'
    }).then((result) => {
      if (result.value) {
        this.router.navigate(['/iniciar'], { replaceUrl: true });
      }
    })
  }
  
  async enviarSolicitud(){
    if(this.esGrupal){
      if(!this.numPersonas || this.numPersonas < 2){
        this.toastr.error('Si selecciona solicitud grupal debe de incluir a más de una persona', '');
        return;
      }
    }else{
      this.numPersonas = 1
    }

    if(this.listNuevasPersonas.length == 0){
      this.toastr.error('Ingrese al menos sus datos de usuario', '');
      return;
    }
    Swal.fire({
      title: '¿Esta seguro de enviar su solicitud?',
      text: "",
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#6c757d',
      cancelButtonText: 'No',
      confirmButtonText: 'Sí, enviar mi solicitud'
    }).then(async (result) => {
      if (result.value) {
        try {
          this.enviando = true;
          await this.guardarSolicitud();
          Swal.fire(
            '¡Su solicitud se ha enviado!',
            'Debe esperar que sea aprobada por el administrador del área para su ingreso',
            'success'
          );

        }catch(error){
          console.log(error);
          this.enviando = false;
        }
      }
    })
  }

  async get_DetalleXEstado(){
    try {
      var response = await this.baseService.get_DetalleXEstado({}).toPromise();
      this.listVisitantesActuales = response;
    }catch(error){
      console.log(error);
    }
  }

  async marcarSolicitud(item, idEstado){
    try {
      var response = await this.baseService.aprobar_Solicitud({idSolicitud: item.idSolicitud, idEstado: idEstado}).toPromise();

      item.idEstado = idEstado;
      var data = {idSolicitud: item.idSolicitud};
      var personal: any = await this.baseService.get_SolicitudesPersonal(data).toPromise();

      var data2 = {
        email: '',
        idSolicitud:0,
        idPersonal: 0,
        tipo: idEstado == 2 ? 'Aprobada' : 'Rechazada',
        empresa: item.empresa,
        area:  item.area,
        fecha: 'Desde el '+ this.formatedDateUser(item.fechaInicio) + ' hasta el ' + this.formatedDateUser(item.fechaFin),
        nombre: ''
      }
      var _estado = idEstado;

      if(personal.length > 0){
        personal.forEach(async x =>  {
          if(x.idEstado == 1){
            if(typeof x.aprobado !== "undefined"){
              var estado = x.aprobado ? 2 : 3;
            }
            data2.idSolicitud = item.idSolicitud,
            data2.idPersonal = x.idPersonal,
            data2.email = x.email;
            data2.nombre = x.nombres + ' ' + x.apellidos;
            await this.baseService.enviar_email(data2).toPromise();
            await this.setEstadoPersonal(data2.idSolicitud, x.idPersonal, _estado);
          }    
        });
      }

      this.toastr.success('La solicitud ha sido modificada');
  
    } catch(error) {
      this.toastr.error('Ha ocurrido un problema');
    }
  }

  async marcarSolicitudIndividual(item, idEstado){
    await this.setEstadoPersonal(item.idSolicitud, item.idPersonal, idEstado);
    if(idEstado== 2 || idEstado == 3){
      var data2 = {
        email: item.email,
        idSolicitud:item.idSolicitud,
        idPersonal: item.idPersonal,
        tipo: idEstado == 2 ? 'Aprobada' : 'Rechazada',
        empresa: item.empresa,
        area:  item.area,
        fecha: 'Desde el '+ this.formatedDateUser(item.fechaInicio) + ' hasta el ' + this.formatedDateUser(item.fechaFin),
        nombre: item.Persona
      }
      await this.baseService.enviar_email(data2).toPromise();
    }
    this.buscarPersonal(item.idSolicitud);
  }

  async marcarSolicitudModal(content){
    try {
      var response = await this.baseService.aprobar_Solicitud({idSolicitud: this.solicitudSeleccionada.idSolicitud, idEstado: 2}).toPromise();
    
      if(this.listPersonasVisitantes.length > 0){
        this.listPersonasVisitantes.forEach(async x =>  {
          if(x.idEstado == 1){
            var data2 = {
              email : x.email,
              tipo:  x.aprobado ? 'Aprobada' : 'Rechazada',
              empresa: this.solicitudSeleccionada.empresa,
              fecha: 'Desde el '+ this.formatedDateUser(this.solicitudSeleccionada.fechaInicio) + ' hasta el ' + this.formatedDateUser(this.solicitudSeleccionada.fechaFin),   
              area:  this.solicitudSeleccionada.area,
              nombre: x.nombres +' '+ x.apellidos,
              idSolicitud: this.solicitudSeleccionada.idSolicitud,
              idPersonal: x.idPersonal,
            }
            var estado = x.aprobado ? 2 : 3;
            await this.setEstadoPersonal(this.solicitudSeleccionada.idSolicitud, x.idPersonal, estado);
            await this.baseService.enviar_email(data2).toPromise();
          }
        });
      }

      this.get_Solicitudes();
      this.modalService.dismissAll(content);
      this.toastr.success('La solicitud ha sido modificada');
  
    } catch(error) {
      this.toastr.error('Ha ocurrido un problema');
    }
  }

  doTextareaValueChange(ev) {
    try {
      this.motivo = ev.target.value;
    } catch(e) {
      console.info('could not set textarea-value');
    }
  }

  async getUser(rut){
    var usuario = this.listNuevasPersonas.filter(x=> x.rut == rut);
    if(usuario.length > 0){
      this.rut = usuario[0].rut;
      this.nombres = usuario[0].nombres;
      this.apellidos = usuario[0].apellidos;
      this.email = usuario[0].email;
      this.telefono = usuario[0].telefono;
    }else {
      var body = {
        Division: 'DCH',
        Validador: rut,
        Captcha: 0
      }
      var response : any = await this.baseService.sp_Login(body).toPromise();
      if(response.length > 0){
        this.rut = response[0].rut;
        this.nombres = response[0].nombres;
        this.apellidos = response[0].apellidos;
        this.email = response[0].email;
        this.telefono = response[0].telefono;
      }else{
        this.rut = rut;
        this.nombres = '';
        this.apellidos = '';
        this.email = '';
        this.telefono = '';
      }
    }
  }


  resetExclusivo(item, preguntas){
    if(item.pregunta.Exclusivo){
      preguntas.forEach(x=>{
        if(x.pregunta.idPregunta !== item.pregunta.idPregunta){
          x.respuestaUsuario = null;
        }
      });
    }
  }

  validar1(){
    if(!this.motivo || !this.empresa){
      this.toastr.error('Llene todos los campos', '');
      return;
    }

    var _arr = this.tareas.filter(x=> x.seleccionado == true);
    if(_arr.length == 0) {
      this.toastr.error('Indique si realizará alguna actividad', '');
      return;
    }

    let fechaHoy =  moment(); 
    let fechaInicio =  moment(`${this.fechaInicio.year}-${this.fechaInicio.month}-${this.fechaInicio.day} ${this.horaInicio.hour}:${this.horaInicio.minute}`); 
    let fechaFin =  moment(`${this.fechaFin.year}-${this.fechaFin.month}-${this.fechaFin.day} ${this.horaFin.hour}:${this.horaFin.minute}`); 
    

    if(fechaInicio.diff(fechaHoy, 'hours') < 0){
      this.toastr.error('La fecha y hora de inicio no debe ser menor a la fecha y hora actual', '');
      return;
    }

    if(this.verFFin && fechaFin.diff(fechaInicio, 'hours') < 0){
      this.toastr.error('La fecha inicio no debe ser mayor a la fecha fin', '');
      return;
    }

    if(this.verFFin && fechaFin.diff(fechaInicio, 'hours') > 12){
      this.toastr.error('La diferencia entre las fechas no puede superar las 12 horas', '');
      return;
    };

    this.paso1 = false;
    this.paso2 = true;
    this.getTelefonosGerencia(this.areaSeleccionada);
  }

  async openmodal(content, solicitud) {

    if(solicitud !== 0){
      this.solicitudSeleccionada = solicitud;
      await  this.get_SolicitudesPersonal(solicitud.idSolicitud);
    }
    this.modalService.open(content, { size: 'lg' });
    
    //console.log(this.suggestionSelected);
  }

  async validar2(){

    try {
      this.enviando = true;
      await this.guardarSolicitud();
      this.enviando = false;
    }catch(error){
      console.log(error);
      this.enviando = false;
    }


  }

  changeAprobar(data){
    console.log(data);
  }

  atrasUsuario(){
    this.rut = this.listNuevasPersonas[0].rut;
    this.nombres = this.listNuevasPersonas[0].nombres;
    this.apellidos = this.listNuevasPersonas[0].apellidos;
    this.email = this.listNuevasPersonas[0].email;
    this.telefono = this.listNuevasPersonas[0].telefono;
    this.paso3 = false;    
    this.paso2 = true;    
  }

  setDatosUsuarios(data){
    this.rut = data.rut;
    this.nombres = data.nombres;
    this.apellidos = data.apellidos;
    this.email = data.email;
    this.telefono = data.telefono;
  }

  savemodal(content) {
    if(!this.rut || !this.nombres || !this.apellidos || !this.telefono){
      this.toastr.error('Por favor llenar todos los campos', '');
      
      return;
    }
    
    if(this.verCorreo && !this.verCorreo){
      this.toastr.error('Por favor llenar todos los campos', '');  
      return;
    }

    if(this.verCorreo && !this.validateEmail()) {
      this.toastr.error('Ingrese correctamente el email', '');
      return;
    }

    if(this.paso2){
      this.paso2 = false; 
      this.paso3 = true;
    }
    
    var user = {
      rut: this.rut,
      nombres: this.nombres,
      apellidos: this.apellidos,
      email: this.email,
      telefono: this.telefono,
      esPrincipal: this.storage.Validador == this.rut ? 1 : 0,
    }
    this.listNuevasPersonas = this.listNuevasPersonas.filter(x=> x.rut !== this.rut);
    this.listNuevasPersonas.push(user);
    this.modalService.dismissAll(content);
    this.rut = '';
    this.nombres = '';
    this.apellidos = '';
    this.email = '';
    this.telefono = '';
    this.disableRut = false;
  }

  formatedDate(fecha, hora){
    return moment(`${fecha.year}-${fecha.month}-${fecha.day} ${hora.hour}:${hora.minute}`, "YYYY-MM-DD H:m").format("YYYY-MM-DD HH:mm:ss");
  }
  
  
  formatedDateUser(fecha){
    return moment(fecha, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm");
  }
  

  async guardarSolicitud(){

    //funcion que hace el guardado de la solicitud

    var _esBloqueado = 0;
    if(this.tareas.length > 0) {
      this.tareas.forEach(tarea => {
        if(tarea.seleccionado && tarea.EsCritico) {
          _esBloqueado = 1;
        }
      });
    }

    var body= {
      idArea: this.areaSeleccionada, 
      fechaInicio: this.formatedDate(this.fechaInicio, this.horaInicio), 
      fechaFin: this.formatedDate(this.fechaFin, this.horaFin),
      motivo: this.motivo,
      empresa: this.empresa,
      numPersonas: this.numPersonas,
      esBloqueo: _esBloqueado
      //esBloqueo: this.esBloqueo ? 1 : 0
    }
    var solicitud : any = await this.baseService.add_Solicitud(body).toPromise();
    var _empresa = this.listEmpresas.filter(y=> y.idEmpresa == this.empresaSeleccionada);
    var _area = this.listArea.filter(y=> y.idArea == this.areaSeleccionada);
    _empresa = _empresa.nombre;
    _area = _area.nombre;
    

    this.rutaQRCompartir = await window.location.protocol+'//'+ window.location.hostname+( window.location.port ? ':'+ window.location.port: '')  +'/#/qr/'+ solicitud[0].idSolicitud;

    await this.tareas.forEach(async tarea => {
      if(tarea.seleccionado) {
        await this.baseService.add_TareasSolicitud({
            idSolicitud: solicitud[0].idSolicitud,
            idTarea: tarea.idTarea
        }).toPromise();
      }
    });


    await this.listNuevasPersonas.forEach( async x =>  {


      var body1 ={
        nombres: x.nombres, 
        apellidos: x.apellidos,
        email	: x.email,
        telefono: x.telefono,
        idEmpresa: this.empresaSeleccionada,
        empresa: '',
        rut: x.rut
      }
      this.rutaQRPase = this.rutaQRPase =  window.location.protocol+'//'+ window.location.hostname+( window.location.port ? ':'+ window.location.port: '')  +'/#/check/'+ x.rut;

      var personal : any = await this.baseService.add_Personal(body1).toPromise();
      var solicitudPersonal : any = await this.baseService.add_SolicitudPersonal({
        idSolicitud: solicitud[0].idSolicitud, 
        idPersonal	: personal[0].idPersonal, 
        esPrincipal: x.esPrincipal ? 1 : 0
      }).toPromise();



      var data2 = {
        email: '', 
        tipo: 'Enviada',
        empresa: _empresa,
        area:  _area,
        fecha: 'Desde el '+ body.fechaInicio + ' hasta el ' + body.fechaFin,
        nombre: '',
        idSolicitud: '',
        idPersonal: '',
      }
      data2.idSolicitud = solicitud[0].idSolicitud,
      data2.idPersonal = personal[0].idPersonal,
      data2.email = x.email;
      data2.nombre = x.nombres + ' ' + x.apellidos;
      if(this.esGrupal){
        var elemC = document.getElementById('QRcompartir').querySelectorAll('div, img');
        var qrC = elemC[0].innerHTML.replace('">', '').replace('<img src="', '');  
        await this.baseService.add_QRSolicitud({idSolicitud: solicitud[0].idSolicitud, QRCode: qrC}).toPromise();
      }

      var elemP = document.getElementById('QRPase').querySelectorAll('div, img');
      var qrP = elemP[0].innerHTML.replace('">', '').replace('<img src="', '');
      
      await this.baseService.add_QRSolicitudPersona({idSolicitud: solicitud[0].idSolicitud, idPersonal: data2.idPersonal, QRCode: qrP}).toPromise();
      this.enviando = false;
      this.paso3 = false;
      this.reset(); 
      this.esAdministrador=false;
      //await this.baseService.enviar_email(data2).toPromise();
    });
    //this.get_Solicitudes();
    //this.mostrarDeclaracion = true; 
    //this.toastr.success('Su solicitud se ha enviado satisfactoriamente', '');
  }
  
  async getHash(){
    try{
      var _storage = JSON.parse(localStorage.getItem('data'));
      if(_storage){
        var response: any = await this.baseService.get_GUID({}).toPromise();
        this.hash = response[0].HashCode;
      }
      
    }catch(error){
      console.log(error);
    }    
  }


  quitarPersonal(item: any){
    this.listNuevasPersonas = this.listNuevasPersonas.filter(x=> x.rut !== item.rut);
  }

  async getSolicitudesPersona(data){
    try {
      var response:any = await this.baseService.get_SolicitudesPersona(data).toPromise();
      this.cargando = false;
      if(response.length > 0){ 
        this.mostrarEstado = true;
        this.paso1 = false;
        this.solicitud = response[0];
        this.rutaQRCompartir =  window.location.protocol+'//'+ window.location.hostname+( window.location.port ? ':'+ window.location.port: '')  +'/#/qr/'+ response[0].idSolicitud;
        this.rutaQRPase =  window.location.protocol+'//'+ window.location.hostname+( window.location.port ? ':'+ window.location.port: '')  +'/#/check/'+ response[0].rut;
        this.getTelefonosGerencia(response[0].idArea);

        this.getTodoPersonal({idSolicitud: response[0].idSolicitud});
      }else{
        this.mostrarEstado = false;
      }
      return response;
    }catch(error) {
      console.log(error);
    }
  }

  async set_estado_solicitud_personal(data){
    try {
      var response:any = await this.baseService.set_estado_solicitud_personal(data).toPromise();
      this.toastr.success('El estado de la solicitud ha sido modificado','');
    }catch(error) {
      console.log(error);
    }
  }

  async get_EstadoSolicitud(){
    try {
      var response:any = await this.baseService.get_EstadoSolicitud().toPromise();
      this.listEstadosSolicitudPersonal = response;
    }catch(error) {
      console.log(error);
    }
  }

  async setEstadoPersonal(idSolicitud, idPersonal, estado){
    var data = {idSolicitud: idSolicitud, idPersonal: idPersonal, idEstado: estado};
    await this.set_estado_solicitud_personal(data);
    if(!this.esAdministrador){      
      this.reset();
      if(estado == 5){
        this.mostrarEstado = false;
      }
    }
  }

  

  reset(){
    var body = {
      Division: 'DCH',
      Validador: this.storage.Validador,
      Captcha: 0
    }
    this.mostrarDeclaracion = false;
    this.getLogin(body);
  }
  
  async getLogin(body){
    try{
      var response : any = await this.baseService.sp_Login(body).toPromise();
      if(response.length > 0){
        this.cargando = true;
        this.getSolicitudesPersona({idPersonal: response[0].idPersonal});
        this.setDatosUsuarios(response[0]);
        this.listNuevasPersonas.push(response[0]);
        if(this.interval){
          setInterval(()=>{
            if(!this.paginaRealizarOtra){
              var solicitud =  this.getSolicitudesPersona({idPersonal: response[0].idPersonal});
            }    

          }, 30000);
          this.interval = false; 
        }

      }else{
        this.disableRut = true; 
        this.rut = this.storage.Validador
      }

      this.paso1 = true;
    }catch(error){
      console.log(error);
      //this.router.navigate(['/'], { replaceUrl: true });
    }    
  }

  async add_Resultado(data){
    try{
      var response: any = await this.baseService.add_Resultado(data).toPromise();
      return response;
    }catch(error){
      console.log(error);
    }    
  }

  async get_Solicitudes(){
    try{
      var body = {
        Division: 'DCH',
        Validador: this.storage.Validador,
        Captcha: 0
      }
      var response : any = await this.baseService.sp_Login(body).toPromise();
      var data = {idEmpresa: 'DCH', fechaInicio: this.rangoFechaInicio, fechaFin: this.rangoFechaFin, idPersonal: response[0].idPersonal};
      var response: any = await this.baseService.get_Solicitudes(data).toPromise();

      response.map(x=>{
        x.fechaI = this.formatedDateUser(x.fechaInicio);
        x.fechaF = this.formatedDateUser(x.fechaFin);
      });
      this.listSolicitudes = response;
      this.listSolicitudesFilter = JSON.parse(JSON.stringify(response));
      this.get_DetalleXEstado();
    
      return response;
    }catch(error){
      console.log(error);
    }    
  }

  changeAreaFilter($event){
    this.listSolicitudesFilter = this.listSolicitudes.filter(x=> x.idArea == $event.target.value);
  }

  changeCompanyFilter($event){
    this.listSolicitudesFilter = this.listSolicitudes.filter(x=> x.idEmpresa == $event.target.value);
  }

  changeSolicitudFilter(){
    if(this.buscarSolicitud == ''){
      this.listSolicitudesFilter = this.listSolicitudes;
    }else{
      this.listSolicitudesFilter = this.listSolicitudes.filter(x=>  x.idSolicitud.toString().indexOf(this.buscarSolicitud.toString()) !== -1);
    }

  }

  async get_SolicitudesPersonal(idSolicitud:any){
    try{
      var data = {idSolicitud: idSolicitud};
      var response: any = await this.baseService.get_SolicitudesPersonal(data).toPromise();
      this.listPersonasVisitantes = response;
      this.listPersonasVisitantes.map(x=> x.aprobado = true);
      return response;
    }catch(error){
      console.log(error);
    }    
  }

  async getTodoPersonal(data:any){
    try{
      var response: any = await this.baseService.get_SolicitudesPersonal(data).toPromise();
      if(response.length > 0){
        this.listPersonal = response;
      }
      return response;
    }catch(error){
      console.log(error);
    }    
  }

  copyURL(val: string){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastr.success('URL copiada en el portapapeles','');
  }


  async buscarPersonal(idSolicitud:any){
    try{
      var body = {
        Division: 'DCH',
        Validador: this.storage.Validador,
        Captcha: 0
      }
      var response : any = await this.baseService.sp_Login(body).toPromise();
      var data = {texto: this.buscar, idEmpresa: 'DCH', fechaInicio: this.rangoFechaInicio, fechaFin: this.rangoFechaFin, idPersonal: response[0].idPersonal};
      var response: any = await this.baseService.get_Solicitudes(data).toPromise();
      response.map(x=>{
        x.fechaI = this.formatedDateUser(x.fechaInicio);
        x.fechaF = this.formatedDateUser(x.fechaFin);
      });

      this.listEncontrados = response;

    }catch(error){
      console.log(error);
    }    
  }

  async enviar_email(data){
    try{
      var response: any = await this.baseService.enviar_email(data).toPromise();
      return response;
    }catch(error){
      console.log(error);
    }    
  }
  async add_Solicitud(data){
    try{
      var response: any = await this.baseService.add_Solicitud(data).toPromise();
      return response;
    }catch(error){
      console.log(error);
    }    
  }

  async add_SolicitudPersonal(data){
    try{
      var response: any = await this.baseService.add_SolicitudPersonal(data).toPromise();
      return response;
    }catch(error){
      console.log(error);
    }    
  }

  async add_Personal(data){
    try{
      var response: any = await this.baseService.add_Personal(data).toPromise();
      return response;
    }catch(error){
      console.log(error);
    }    
  }

  async get_Tareas(){
    try{
      var response: any = await this.baseService.get_Tareas({}).toPromise();
      //this.tareas.filter(y=> y.Exclusivo).map(x=> x.seleccionado =);
      this.tareas =  response;
    }catch(error){
      console.log(error);
    }    
  }
  
  async getAreas(){
    try{
      this.loading = false;
      var _storage = JSON.parse(localStorage.getItem('data'));  
      var _areas: any = await this.baseService.get_areas('DCH').toPromise();
      this.listArea = _areas;
      this.areaSeleccionada = _areas[0].idArea;

      //this.getTelefonosGerencia(_areas[0].idArea);

      this.loading = false;
    }catch(error){
      console.log(error);
    }    
  }

  async getTelefonosGerencia(idArea){
    this.telefonosGerencia = [];
    var telefonos: any = await this.baseService.get_telefonosGerencia({Division: 'DCH', idArea: idArea}).toPromise();
      if(telefonos){
        if(telefonos.length > 0){
          telefonos.forEach(item => {
            if(item.telefono){
              this.telefonosGerencia.push({telefono: item.telefono, area: item.nombre, gerencia: item.gerencia});
            }
          });
        }
      }
  }

  async getEmpresas(){
    try{
      this.loading = false;
      var _storage = JSON.parse(localStorage.getItem('data'));  
      var data: any = await this.baseService.get_empresas().toPromise();
      this.listEmpresas = data;
      this.empresaSeleccionada = data[0].idEmpresa;
      this.loading = false;
    }catch(error){
      console.log(error);
    }    
  }

  changeCompany(event){
    this.empresaSeleccionada = event.target.value;
  }

  async changeArea(event){

    //this.areaSeleccionada = event.target.value;
    if(event){

      this.areaSeleccionada = event.idArea;
      var _area =  this.listArea.find(x=> x.idArea == this.areaSeleccionada);
      this.verFFin =_area.verFFin;
      this.verCorreo =_area.verCorreo;
      
    }
    
  }

  validateEmail() {
    var response = false
    var email = this.email; 
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    response = re.test(String(email).toLowerCase());
    this.emailIncorrecto = response ? false : true;
    return response;
  }


  toggleVisibility(show) { 
    this.show = show;
  }

  toggleVisibility2(show) { 
    this.show2 = show;
  }

  backPoll(stepper){
    this.router.navigate(['/iniciar'], { replaceUrl: true });
    stepper.reset()
  }
  
  getDates() {
    var dateArray = [];
    var currentDate:any =  this.rangoFecha.startDate;
    var stopDate:any = this.rangoFecha.endDate;
    while (currentDate <= stopDate) {
        dateArray.push( moment(currentDate).format('YYYY-MM-DD') )
        currentDate = moment(currentDate).add(1, 'days');
    }
    return dateArray;
  }


  getDataChart(dates){
    var arrayData = [];
    dates.forEach(y=>{
      this.listArea.forEach(area=>{
        var _data = this.listSolicitudes.filter(x=> x.area == area.nombre && moment(x.fechaCreacion).format('YYYY-MM-DD') == y);
        if(_data){
          arrayData.push({name: area, values: _data.length});
        }
   
      });
    }); 
    return arrayData;
  }

  getDataChartAll(dates){
    var arrayData = [];
    var _data = this.listVisitas;
    dates.forEach(y=>{
      var data = 0
      _data.forEach(x=> {      
        var dia =  moment(x.fecha).format('YYYY-MM-DD'); 
        if(y == dia){
          data = data + 1;
        }
      });

      arrayData.push(data);
    });  
    return arrayData;
  }

  formatedRut(rut: any, $event: any) {
    if (rut) {
      var _rut =this.formatRut(rut, $event)
      
      this.getUser(_rut)
      return _rut;
    } else {
      return null;
    }
  }
    
  formatRut (texto: any, event: any) {
    if (
      event &&
      event.type != 'blur' &&
      event.code != 'Enter' &&
      event.code != '13' &&
      event.code != 13 &&
      event.charCode != '13' &&
      event.charCode != 13
    )
      return texto;

    if (texto === null || texto === undefined) return null;
    var size = texto.length;
    if (size == 1) return texto;

    //console.log('Antes: ' + texto);
    //si tiene puntos (.) o guiones (-) se los saca
    texto = (texto.slice(0, size - 1).replace(/[^\d]/gi, '') + texto.slice(size - 1).replace(/[^\d^k]/gi, '')).replace(
      /^[0]*/g,
      ''
    );
    //console.log('Después: ' + texto);

    var number = texto.substring(0, texto.length - 1);
    var dv = texto.substring(texto.length - 1);
    //agrega los puntos (.) y el guión (-)
    var rut =
      number.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, function($1) {
        return $1 + '.';
      }) +
      '-' +
      dv;
    //console.log(rut);

    return rut;
  }


  choosedDate(e) {
    this.inlineDate = e;
  }
  choosedDateTime(e) {
    this.inlineDateTime = e;
  }
  open(e) {
    //this.pickerDirective.open(e);
  }
  clear(e) {
    this.rangoFecha = null;
  }
    
}
